<template>
	<PageArrows 
		v-bind:className="'patient'"
		v-bind:linkPrev="`/patient/${which}/${content[which].prevTab}`"
		v-bind:linkNext="`/patient/${which}/${content[which].nextTab}`"
		v-bind:linkNextInterim="content[which].nextTabInterim"
		v-bind:questionPopupDisplay="questionPopupDisplay"
		v-on:load-interim="loadInterim"
	></PageArrows>
	<ColumnLayout
		v-bind:which="which"
		v-bind:tabType="tabType"
		v-bind:content="content"
		v-bind:questionPopupDisplay="questionPopupDisplay"
		v-on:show-overlay="showOverlay"
	></ColumnLayout>
	<teleport to="body">
		<QuestionPopup
			v-if="content[which].InterimQA && questionPopupDisplay"
			v-bind:which="which"
			v-bind:tabType="tabType"
			v-bind:content="content"
			v-on:close-then="closeThen()"
		></QuestionPopup>
	</teleport>
	<teleport to="body">
		<OverlayModal 
			v-if="content[which].columnOverlay && overlayDisplay" 
			v-bind:which="which"
			v-bind:tabType="tabType"
			v-bind:content="content"
			v-on:show-overlay="showOverlay"
			id="overlay-modal"
		>
			<TabbedContent
				v-bind:which="which"
				v-bind:tabType="'cycle-1'"
			>
			</TabbedContent>
		</OverlayModal>
	</teleport>
</template>
<script>
import PageArrows from '@/components/PageArrows'
import ColumnLayout from '@/components/ColumnLayout'
import QuestionPopup from '@/components/QuestionPopup'
import OverlayModal from '@/components/OverlayModal'
import TabbedContent from '@/components/TabbedContent.vue'
export default {
	components: {
		PageArrows,
		ColumnLayout,
		QuestionPopup,
		OverlayModal,
		TabbedContent
	},
	data() {
		return {
			which: this.$route.params.which,
			tabType: 'cycle-2',
			overlayDisplay: false,
			questionPopupDisplay: false,
			content: {
				carson: {
					classes: 'cycle',
					prevTab: 'cycle-1/',
					nextTab: 'cycle-3/',
					nextTabInterim: true,
					columnA: 199,
					columnAalt: 199,
					columnAclass: 'button-shift',
					columnAbutton: 199,
					columnButtonAction: 'show-overlay',
					columnOverlay: 'cycle-1',
					columnB: 405,
					columnBalt: 405,
					columnC: 305,
					columnChide: true,
					InterimQA: {
						layoutClass: 'two-col checkboxes carson-cycle-2',
						type: 'radio',
						question: 'How would you manage Mr. Carson\'s venetoclax dosing in Cycle 2 based on his Grade 4 neutropenia lasting at least 7 days?',
						choices: [
							'Continue on venetoclax and initiate Cycle 3<br> without delay',
							'Delay Cycle 3 until neutropenia has resolved to<br> Grade 1 or 2, and resume venetoclax at the same dose',
							'Delay Cycle 3 until neutropenia has resolved to Grade 1 or 2,<br> and resume venetoclax at a reduced dose (200 mg)',
							'Delay Cycle 3 until neutropenia has resolved to<br> Grade 1 or 2, and resume venetoclax on a 21/28-day schedule'
						],
						altAnswer: 'Given that Mr. Carson has blast clearance, delay the subsequent cycle until neutropenia has resolved to Grade 1 or 2. Since it is the first occurrence after achieving remission, resume at the same dosing schedule.',
						keepBR: true,
						answer: '0',
						answerSize: 957
					}
				}
			}
		}
	},
	methods: {
		loadInterim(){
			this.questionPopupDisplay = true
		},
		closeThen(){
			this.questionPopupDisplay = false
			this.content[this.which].columnChide = false
			this.content[this.which].nextTabInterim = false
		},
		showOverlay(whichActions){
			switch(whichActions[0]){
				case 'show-overlay':
						this.overlayDisplay = whichActions[1]
					break;
			}
		}
	}
}
</script>
<style scoped>

</style>